<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template #activator="{ on, attrs }">
      <v-btn color="primary" dark right v-bind="attrs" v-on="on">
        PDF erstellen
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">PDF-Einstellungen</span>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6">
              <v-select
                v-model="term"
                :readonly="termid ? true : false"
                :items="terms"
                label="Laufzeit"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select v-model="view" :items="designs" label="Angebotsart" />
            </v-col>
          </v-row>
          <v-row>
            <v-checkbox v-model="full" label="mit Vertragstext" value="true" />
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn left @click="dialog = false">
          zurück
        </v-btn>
        <v-spacer />
        <a
          target="_blank"
          :href="
            route('offerData.pdf', {
              offerData: orderid,
              term,
              view,
              full: full,
            })
          "
        >
          <v-btn color="primary"> Öffnen </v-btn>
        </a>
        <a
          target="_blank"
          :href="
            route('offerData.download', {
              offerData: orderid,
              term,
              view,
              full: full,
            })
          "
        >
          <v-btn color="primary"> Download </v-btn>
        </a>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
   name: 'OrderExport',
   props: {
      orderid: {
         type: Number,
         required: true,
      },
      termid: {
         type: Number,
         required: true,
      },
   },
   data () {
      return {
         full: null,
         dialog: false,
         term: 3,
         view: 'telekom_budget',
         terms: [
            { text: '36 Monate', value: 2 },
            { text: '60 Monate', value: 3 },
         ],
      }
   },
   computed: {
      designs () {
         const designs = [{ text: 'Telekom', value: 'telekom_budget' }]
         designs.push({ text: 'Telekom EF', value: 'telekom_budget_ef' })
         if (this.$page.props.user.permissions.offer.nwt_view) {
            designs.push({ text: 'NWT', value: 'nwt' })
         }
         if (this.$page.props.user.permissions.offer.admin_view) {
            designs.push({ text: 'Vorleister', value: 'vorleister' })
         }
         return designs
      },
   },
   created () {
      if (this.termid) {
         this.term = this.termid
      }
   },
   methods: {},
}
</script>
